/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($, Tc) {
	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.7 or greater,
	 * jquery.placeholder.min.js,
	 */

	'use strict';

	/**
	 * Wireline module implementation.
	 *
	 * @author
	 * @namespace Tc.Module
	 * @class Wireline
	 * @extends Tc.Module
	 */
	Tc.Module.Wireline = Tc.Module.extend({

		Elements: {
			Fallback: '.fallback',
			LoadingIndicator: '.loading-indicator',
			ResultContainer: '.result-container'
		},

		/**
		 * Initializes the module.
		 *
		 * @method init
		 * @constructor
		 * @param {jQuery} $ctx the jquery context
		 * @param {Sandbox} sandbox the sandbox to get the resources from
		 * @param {String} modId the unique module id
		 */
		init: function($ctx, sandbox, modId) {
			this.$ctx = $ctx;
			this.config = {
				url: $ctx.data('url'),
				zipFieldName: $ctx.data('zip-field'),
				cityFieldName: $ctx.data('city-field'),
				updateOnChange: $ctx.data('update-on-change'),
				displayOnlySingleContact: $ctx.data('display-single-contact')
			};

			// call base constructor
			this._super($ctx, sandbox, modId);
		},

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function(callback) {
			this.zipField = this.getField(this.config.zipFieldName);
			this.cityField = this.getField(this.config.cityFieldName);
			$('.update-results', this.$ctx).on('click', $.proxy(this.onSearchClick, this));
			this.getResultContainer().on('click', '.on-list-item-click', $.proxy(this.onListItemClick, this));
			callback();
		},

		/**
		 * Hook function to trigger your events.
		 *
		 * @method after
		 * @return void
		 */
		after: function() {
			if (this.config.updateOnChange && this.config.displayOnlySingleContact) {
				this.refresh();
			}
		},

		getField: function(name) {
			var $this = this,
				field = {
					name: name,
					field: $this.getFieldByName(name),
					init: function() {
						if (this.field) {
							this.field.on('change', $.proxy($this.onFieldValueChanged, $this));
							this.field.on('keypress', $.proxy($this.onKeyPress, $this));
						}
					},
					getValue: function() {
						if (this.field) {
							return this.field.val();
						}
						return null;
					}
				};
			field.init();
			return field;
		},

		getFieldByName: function(name) {
			if (name) {
				return $('input[name="' + name + '"]');
			}
			return null;
		},

		getResultContainer: function() {
			if (!this.resultContainer) {
				this.resultContainer = $(this.Elements.ResultContainer, this.$ctx);
			}
			return this.resultContainer;
		},

		onFieldValueChanged: function() {
			if (this.config.updateOnChange) {
				this.refresh();
			}
		},

		onKeyPress: function(event) {
			if(event.keyCode === 13) {
				this.refresh();
			}
		},

		onSearchClick: function() {
			this.refresh();
		},

		onListItemClick: function(event) {
			var item = this.getSavedItem($(event.currentTarget).data('index'));
			if (item) {
				this.refresh({
					'postcode': item.postcode,
					'city': item.city
				});
			}
		},

		onLoadDataSuccess: function(data) {
			this.showElement(this.Elements.LoadingIndicator, false);
			if (data.success === true) {
				this.saveItems(data.items);
				if (data.type === 'contacts') {
					this.displayContacts(data.items);
				} else {
					this.displayCities(data.items);
				}
			} else {
				this.onLoadDataError();
			}
		},

		onLoadDataError: function() {
			this.showElement(this.Elements.LoadingIndicator, false);
			this.showElement(this.Elements.Fallback, true);
		},

		refresh: function(customData) {
			var $this = this,
				data = $this.getRequestData();
			if (customData) {
				$.extend(data, customData);
			}
			this.showElement(this.Elements.Fallback, false);
			this.showElement(this.Elements.LoadingIndicator, true);
			this.showElement(this.Elements.ResultContainer, false);
			if($this.$ctx.find('.city span.error').is(':visible') && $this.$ctx.find('.zipCountry input').val().length === 0) {
				$this.$ctx.find('.city span.error').addClass('hidden');
			}
			this.getResultContainer().empty();
			this.ajaxCall = $.ajax({
				type: 'GET',
				url: $this.config.url,
				cache: false,
				dataType: 'json',
				data: data,
				success: $.proxy($this.onLoadDataSuccess, $this),
				error: $.proxy($this.onLoadDataError, $this)
			});
		},

		getRequestData: function() {
			var $this = this,
				requestData = {
					'_charset_': 'utf-8',
					'postcode': $this.zipField.getValue(),
					'city': $this.cityField.getValue()
				};
			return requestData;
		},

		showElement: function(type, show) {
			if (!this.elements) {
				this.elements = {};
			}
			if (!this.elements[type]) {
				this.elements[type] = $(type, this.$ctx);
			}
			if (show) {
				if (type === this.Elements.LoadingIndicator && this.elements[this.Elements.ResultContainer]) {
					this.elements[type].height(Math.max(35, this.elements[this.Elements.ResultContainer].height()));
				}
				this.elements[type].removeClass('hidden');
			} else {
				this.elements[type].addClass('hidden');
			}
		},

		saveItems: function(items) {
			this.savedItems = items;
		},

		getSavedItem: function(index) {
			if (this.savedItems && typeof index === 'number' && this.savedItems.length > index) {
				return this.savedItems[index];
			}
			return null;
		},

		getCitiesTemplate: function() {
			if (!this.listTemplate) {
				var templateScript = this.$ctx.find('script.tmpl-cities');
				this.listTemplate = window.doT.template(templateScript.html());
			}
			return this.listTemplate;
		},

		getContactsTemplate: function() {
			if (!this.itemTemplate) {
				var templateScript = this.$ctx.find('script.tmpl-contacts');
				this.itemTemplate = window.doT.template(templateScript.html());
			}
			return this.itemTemplate;
		},

		displayCities: function(list) {
			if (list.length > 0 && !this.config.displayOnlySingleContact) {
				this.showElement(this.Elements.Fallback, false);
				this.showElement(this.Elements.ResultContainer, true);
				this.getResultContainer().html(this.getCitiesTemplate()(list));
			} else {
				this.showElement(this.Elements.Fallback, true);
			}
		},

		displayContacts: function(items) {
			if (items.length > 0 && (!this.config.displayOnlySingleContact || (this.config.displayOnlySingleContact && items.length === 1))) {
				this.showElement(this.Elements.Fallback, false);
				this.showElement(this.Elements.ResultContainer, true);
				this.prepareContacts(items);
				this.getResultContainer().html(this.getContactsTemplate()(items));
			} else {
				this.showElement(this.Elements.Fallback, true);
			}
		},

		prepareContacts: function(contacts) {
			for (var i = 0; i < contacts.length; i += 1) {
				if (contacts[i].officeTime) {
					contacts[i].officeTime = contacts[i].officeTime.replace('(', '').replace(')', '');
				}
			}
		}
	});

}(window.Tc.$, window.Tc));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.Wireline.js
// module id = 197
// module chunks = 0